<template>
  <div>
          <div class = "small" >
               <div id="barra" style="width:100%;height:15%">
                  <div id="titulo" style="width:50%"><a> {{this.datacollection.titulo_grafico}}</a></div>
                  <div id="botones" style="width:65%;height:50%">    
                      <b-button class="buttonHoras" id = "horas" v-on:click="filtroTiempo($event)">Horas</b-button>
                      <b-button class="buttonDias" id = "dias" v-on:click="filtroTiempo($event)">Días</b-button>
                      <b-button class="buttonSemanas" id = "semanas" v-on:click="filtroTiempo($event)">Semanas</b-button>
                      <b-button class="buttonMeses" id = "meses" v-on:click="filtroTiempo($event)">Meses</b-button>
                  </div> 
                  <div><img src = "../assets/Logo-Neumomed-para-PlayStore.png" style="height:60px;"></div>  
               </div>
            <br>
            <label id="tituloPrograma" class="tituloPrograma"></label>  
            <apexchart :type="type" :options="options" v-bind:series="series"></apexchart>   
            <!--<chartjs-bar v-bind="datacollection" v-bind:option="options" :barWidth="barWidth" style="width:90%; margin:auto"></chartjs-bar>-->
            <br>
            <div class="slidecontainer">
              <input type="range" class="slider" id="slider" v-on:change="sliderValue()"  min="1" max="30" step="1" value="0">
              <a style="color:#666666;font-size: 1.0vw;">{{this.sliderMinValue}}</a><a style="color:#666666;position:relative;left:95%;font-size:  1.0vw;">{{this.sliderMaxValue}}</a>
            </div>
            <center><a id = "currentValue" style="color:#666666;font-size: 1.0vw;">{{this.sliderCurrentValue}}</a></center>
          </div>
  </div>
</template>

<script>
import metodos_comunes from '../js/metodos_comunes'
import { serverBus } from '../main'
import vueSlider from 'vue-slider-component';
import VueApexCharts from 'vue-apexcharts'
import Vue from 'vue';
Vue.component('apexchart', VueApexCharts)


var upBarColor = "#999999"
var downBarColor = "#737373"
var textColor="#666666"
let sliderChangedMod1 = 0

let json = 
{
  cantidad: "30",
  filtro_tiempo: "dias" 
}
var jsonClient = {
  programa:"p_rhb",
  estado:"no_registrado",
  filtro_tiempo:"dias",
  cantidad:"30",
  filtro_tiempo_gestion:"dias",
  cantidad_gestion:"30"
}

export default {
  props:{
    datacollection: {},
    height:Number,
    series:Array
  },
  components:{
    vueSlider
  },
  data(){
    let self = this
    return {
      x_index: 0, // Es el valor seleccionado  en los graficos (0:rhb, 1:tabaquismo, etc)
      vectorFiltroTiempo: ["horas","dias","semanas","meses"],
      maximosFiltroTiempo: [24,30,4,12],
      sliderMinValue:0,
      sliderMaxValue:30,
      sliderCurrentValue:0,
      type: "bar",
      numberBarsGestion:0,
      numberBarsRegistro:0,
      pushButtonColor:"#3399cc",
      labelProgramaSeleccionado:"test",
      options : {
            chart: {
                stacked: true,
                toolbar: {
                    show: true
                },
                zoom: {
                    enabled: true
                },
                events: {
                  dataPointSelection: function(event, chartContext, config) {
                        switch(self.datacollection.modulo){
                          case "gestion_pacientes":
                            self.accionesGestionClick(event, chartContext, config, self)
                            break
                          default:
                            break
                        }
                  }
              }
            },
            dataLabels: {
              enabled: true,
              position: 'bottom',
              style: {
                colors: ['#FFF','#FFF','#000']
              }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                },
            },
            states: {
              normal: {
                  filter: {
                      type: 'none',
                      value: 0,
                  }
              },
              hover: {
                  filter: {
                      type: 'lighten',
                      value: 0.2,
                  },
              },
              active: {
                  allowMultipleDataPointsSelection: false,
                    filter: {
                        type: 'darken',
                        value: 0.1
                    }
                  },
            },
            responsive: [{
                breakpoint: undefined,
                options: {
                    legend: {
                        position: 'left',
                        offsetX: -10,
                        offsetY: 0
                    }
                }
            }],
            //colors: this.datacollection.backgroundColor,
            colors: [downBarColor, upBarColor, 'rgba(0,0,0,0)'],
            xaxis: {
                //type: 'datetime',
                categories: this.datacollection.labels,
            },
            legend: {
                position: 'bottom',
                offsetY: -10
            },
            fill: {
                opacity: 1
            },
      },
      stroke: {
        width: [5, 7, 5],
        curve: 'straight',
        dashArray: [0, 8, 5]
      }
    }
  },

  /**
   * Funcion llamada al crear el componente
   */
  created(){
    
    switch(this.datacollection.modulo){
      case "gestion_pacientes":
        this.configuraNumeroBarras()
        break
      default:
        break
    }

    setTimeout(() => serverBus.$emit('globalConfiguration',jsonClient));
    //this.displayModulesInit()
    // This function catch the right click
  },

  /**
   * Funcion llamada al montarse el componente
   */
  mounted(){
    switch(this.datacollection.modulo){
      case "gestion_pacientes":
        try{
          this.configuraFiltrosGestion()
        }catch(err){

        }
        break
      default:
        break
    }

    /**
     * Funcion para actualizar graficos, consulta segun programa, filtro_tiempo y cantidad
     * @param {*} refresh tiene las variables de configuracion para recargar los graficos
     */
    serverBus.$on('updateFilters', (refresh) =>{
      let filtro_tiempo;
      let cantidad;

      let filter;
      let modulo = this.datacollection.key_grafico
      let canal;
      let programa;
      let json_dialog_flow = refresh[1]
      let jsonConfig = refresh[2]
      switch(modulo){
        case "registro":
            filtro_tiempo = json_dialog_flow.filtro_tiempo;
            cantidad = json_dialog_flow.cantidad;

            filter = filtro_tiempo

            jsonClient["cantidad"]=cantidad
            jsonClient["filtro_tiempo"]=filtro_tiempo
            jsonClient["estado"]=jsonConfig.filtro

            json["filtro_tiempo"]=filtro_tiempo;
            json["cantidad"]=cantidad;

            if(sliderChangedMod1==2){
              sliderChangedMod1 = 0
            }
            
            if(sliderChangedMod1==0){
              this.sliderCurrentValue = cantidad

              setTimeout(() => serverBus.$emit('globalConfiguration',jsonClient));

              this.$store.dispatch('setJsonRegistro', json)
              this.$store.dispatch('setJsonGestion', jsonClient)
              
              this.actualizaFiltros(filter, this.datacollection.key_grafico);
              //this.listaDePacientes(modulo, jsonConfig.filtro,json_dialog_flow.programa, json_dialog_flow);
            }
            sliderChangedMod1 = sliderChangedMod1 + 1
          break
        case "gestion":
            filtro_tiempo = json_dialog_flow.filtro_tiempo_gestion;
            cantidad = json_dialog_flow.cantidad_gestion;
            canal = json_dialog_flow.canal;
            programa = json_dialog_flow.programa;

            if(json_dialog_flow.cantidad==""){
              json_dialog_flow.cantidad = jsonClient["cantidad"]
            }
            if(json_dialog_flow.filtro_tiempo==""){
              json_dialog_flow.filtro_tiempo = jsonClient["filtro_tiempo"]
            }

            filter = filtro_tiempo
            
            if(json_dialog_flow["estado"]==""){
              //json_dialog_flow["estado"]="no_registrado"
            }
            
            if(sliderChangedMod1==2){
              sliderChangedMod1 = 0
            }
            if(sliderChangedMod1==1){
              this.actualizaFiltros(filter, this.datacollection.key_grafico);
              this.sliderCurrentValue = cantidad

              // Funciones llamadas para mostrar dibujar los modulos1 y modulo2, tambien se llama globalConfiguration para recargar las variables actuales
              setTimeout(() => serverBus.$emit('globalConfiguration',json_dialog_flow));

              this.$store.dispatch('setJsonRegistro', json)
              this.$store.dispatch('setJsonGestion', json_dialog_flow)
              
              //this.setBackgroundColorBars(canal,programa, this.x_index);
            }
            sliderChangedMod1 = sliderChangedMod1 + 1
          break
      }
      
      document.getElementById("slider" + this.datacollection.key_grafico).value = parseInt(cantidad);
      
    })
  },

  beforeDestroy(){
    serverBus.$off('updateFilters')
  },

  methods:{
      configuraNumeroBarras:function(){
        
        if(this.datacollection.key_grafico=="registro"){
          try{
            labelPrograma[0].id = "tituloProgramaRegistro"
            this.numberBarsRegistro = this.series[0].data.length
          }catch(err){

          }
        }else{
          try{
            this.numberBarsGestion = this.series[0].data.length
          }catch(err){
            
          }
        } 
      },

    /**
     * Funcion para configurar los filtros de gestion (tiempo: botones y slider)
     */
      configuraFiltrosGestion:function(){
        var button = document.getElementsByClassName("buttonHoras")
        var button2 = document.getElementsByClassName("buttonDias")
        var button3 = document.getElementsByClassName("buttonSemanas")
        var button4 = document.getElementsByClassName("buttonMeses")

        var slider = document.getElementsByClassName("slider")
        
        var id = this.datacollection.key_grafico
        let index;
        // console.log("boton_seleccionado",button, id)
        switch(id){
          case "registro":
            index = 0
            break
          case "gestion":
            index = 1
            break
        }
        button[index].id = "horas" + id
        button2[index].id = "dias" + id
        button3[index].id = "semanas" + id
        button4[index].id = "meses" + id

        slider[index].id = "slider" + id
        
        document.getElementById("slider" + id).value = jsonClient["cantidad"];
        var canal = "web"
        var programa = "p_rhb"
        //this.setBackgroundColorBars(canal,programa, this.x_index)
      },

      /**
       * Funcion llamada cuando se hace click sobre una barra
       * @param {*} event objeto que tiene informacion asociada al evento click
       * @param {*} chartContext objeto que tiene toda la informacion del grafico
       * @param {*} config objeto que tiene informacion de configuracion (index_x, index_y)
       * @param {*} self como el scope del proyecto no es el mismo del click en barras, debe pasarse el objeto this = self
       */
      accionesGestionClick:function(event, chartContext, config, self){

        var vectorColors1 = [];
        var vectorColors2 = [];
        let filtro = "no_registrado"
        let programa = "" //rhb, tabaquismo, seguimiento, etc
        let pacientes = "" // gestionados/no_gestionados
        let canal = "" // Telefonia, app, google_chat, etc

        // console.log("barra_seleccionada",self.datacollection.key_grafico)

        switch(self.datacollection.key_grafico){

          // Left click module 0(patient register)
          // Module 0 (registro)
          case "registro":
            this.labelProgramaSeleccionado = self.datacollection.labels[config.dataPointIndex]
            let labelPrograma = document.getElementsByClassName("tituloPrograma")
            labelPrograma[1].innerHTML = this.labelProgramaSeleccionado

            programa = self.datacollection.keys[config.dataPointIndex]
            filtro = self.series[config.seriesIndex].filtro //registrado, no_registrado
            jsonClient["estado"] = filtro
            jsonClient["programa"] = programa

            let jsonListaPacientesRegistro = json
            jsonListaPacientesRegistro["filtro"] = filtro
            jsonListaPacientesRegistro["programa"] = programa

            // console.log("listaPacientes", jsonListaPacientesRegistro)
            serverBus.$emit('listaDePacientes_registro',jsonListaPacientesRegistro);

            // Change color Bars onclick          
            break
          // Module 1 (gestion)
            case "gestion":
                      
              pacientes = self.series[config.seriesIndex].filtro
              canal = self.datacollection.keys[config.dataPointIndex]
              serverBus.$emit('listaDePacientes',([pacientes, canal, jsonClient]));

              break
        } 

        self.x_index = config.dataPointIndex

        self.actualizaFiltrosModulos(self)

        serverBus.$emit('globalConfiguration',jsonClient)
                          
        // Envia mensaje a dialogflow para iniciar conversacion en enviar mensaje
        this.$store.dispatch('setMensajeChatBox', "Enviar mensaje a los pacientes seleccionados")
        //serverBus.$emit('confirmacionEnvioMensaje',"Enviar mensaje a los pacientes seleccionados"); 
        setTimeout(() => serverBus.$emit('mostrarListaPacientesDesdeControl',true))

      },
      /**
       * Recarga los modulos cuando se crea el componente
       */
        actualizaFiltrosModulos:function(self){
          // console.log("cambioModulo0",jsonClient)
          self.$store.dispatch('setJsonRegistro', json)
          self.$store.dispatch('setJsonGestion', jsonClient)
        },

        /**
         * Esta funcion es llamada cuando se hace click en los botones de filtro de tiempo (horas, dias, semanas, meses).
         * @param {*} event tiene los valores asociados al boton que se selecciono (id, nombre, etc).
         */
        filtroTiempo:function(event){
          
          var vectorButtonColors = ["rgb(0,0,0,0.0)","rgb(0,0,0,0.0)","rgb(0,0,0,0.0)","rgb(0,0,0,0.0)"];
          var vectorTextColors = [textColor,textColor,textColor,textColor]
          var targetId = ""
          let self = this
          let buttonIndex = 0

          targetId = event.currentTarget.id;
          
          document.getElementById("slider" + this.datacollection.key_grafico).value = 1;
          this.sliderCurrentValue = 1;
          this.sliderMinValue = 1
          
          buttonIndex = this.configuraFiltroTiempo(targetId)
          let timeFilter = this.vectorFiltroTiempo[buttonIndex];
          
          vectorButtonColors[buttonIndex] = this.pushButtonColor;
          vectorTextColors[buttonIndex] = "white"

          this.vectorFiltroTiempo.map(function(valores, index){
            document.getElementById(valores + self.datacollection.key_grafico).style.backgroundColor = vectorButtonColors[index];
            document.getElementById(valores + self.datacollection.key_grafico).style.color = vectorTextColors[index];
          })

          document.getElementById("slider" + this.datacollection.key_grafico).max = this.sliderMaxValue
          
          switch(this.datacollection.key_grafico){
            case "registro":
                jsonClient["filtro_tiempo"]=timeFilter
                jsonClient["cantidad"]="1"
                json["filtro_tiempo"]=timeFilter;
                json["cantidad"]="1"
                this.$store.dispatch('setJsonRegistroCambio', timeFilter)
              break
            case "gestion":
                jsonClient["filtro_tiempo_gestion"]=timeFilter
                jsonClient["cantidad_gestion"]="1"
              break
          } 
          
          this.$store.dispatch('setJsonGestionCambio', timeFilter)
          
          setTimeout(() => serverBus.$emit('globalConfiguration',jsonClient));
        },

        /**
         * Actualiza los filtros desde el chatbot, si fue horas, dias, semanas o meses
         * @param {*} event tiene los valores asociados al boton que se selecciono (id, nombre, etc).
         * @param {*} id id del modulo, 1 para registro, 2 para gestion
         */
        actualizaFiltros:function(event,id){
          
          var timeFilter = ""
          var vectorButtonColors = ["rgb(0,0,0,0.0)","rgb(0,0,0,0.0)","rgb(0,0,0,0.0)","rgb(0,0,0,0.0)"];
          var vectorTextColors = [textColor,textColor,textColor,textColor]
          var targetId = event + id
          
          let buttonIndex = this.configuraFiltroTiempo(targetId)
          
          this.sliderMinValue=1;
          // console.log("json1", "slider" + id)
          document.getElementById("slider" + id).max = this.sliderMaxValue

          timeFilter = this.vectorFiltroTiempo[buttonIndex];
          vectorButtonColors[buttonIndex] = this.pushButtonColor;
          vectorTextColors[buttonIndex] = "white"

          this.vectorFiltroTiempo.map(function(valores, index){
            document.getElementById(valores + id).style.backgroundColor = vectorButtonColors[index];
            document.getElementById(valores + id).style.color = vectorTextColors[index];
          })
        },

        configuraFiltroTiempo:function(targetId){
          let buttonIndex = 0
          switch(targetId){
            case "horas" + this.datacollection.key_grafico:
                buttonIndex = 0
                break
            case "dias" + this.datacollection.key_grafico:
                buttonIndex = 1
                break
            case "semanas" + this.datacollection.key_grafico:
                buttonIndex = 2
                break
            case "meses" + this.datacollection.key_grafico:
                buttonIndex = 3
                break
          }
          this.sliderMaxValue = this.maximosFiltroTiempo[buttonIndex]
          return buttonIndex
        },

        /**
         * Funcion llamada cuando el slider cambia de valor o posicion
         * @param {*} event tiene los valores asociados al slider
         */
        sliderValue:function(event){
            var val = document.getElementById("slider"+this.datacollection.key_grafico).value //Obtiene el valor actual del slider
            this.sliderCurrentValue = val;
            
            switch(this.datacollection.key_grafico){
              case "registro":
                  jsonClient["cantidad"] = val
                  json["cantidad"] = val;
                  this.$store.dispatch('setJsonRegistroCambio', val)
                  break
              case "gestion":
                  jsonClient["cantidad_gestion"] = val
                  break
            } 
            this.$store.dispatch('setJsonGestionCambio', val)
            this.actualizaFiltrosModulos(this)
            setTimeout(() => serverBus.$emit('globalConfiguration',jsonClient));
        },
  }
}
</script>
<style scoped>
body,html{
  min-width: 100%;
  min-height: 100%;
  background-color:white;
}
#titulo{
  color: #666666;
  font-family: 'Nunito', sans-serif;
  font-size: 1.5vw;
  font-weight: bold;
}
#tituloPrograma{
  color: #666666;
  font-family: 'Nunito', sans-serif;
  font-size: 1.4vw;
  font-weight: bold;
  padding: 0px 0px 0px 30px;
}
#botones{
    text-align: center;
}
#barra{
  display: flex;
  justify-content: center;
  align-items: center;
  /* justify-content: space-between; */
  padding: 25px 30px 5px 30px;

}

.small {

  margin: 10px auto;
  background-color:white;
  border-radius: 15px;
  border: 1px solid #cccccc;
  width: 95%;
  height: 80%;
   
}
#ex1Slider .slider-selection {
  background: #666;
}
.slidecontainer {
    position: relative;
    padding: 20px 20px 0px 20px;
    
    top:1%;
        left: 3%;
        width: 95%; /* Width of the outside container */
}
.slider {
    -webkit-appearance: none;
    width: 100%;
    height: 8px;
    border-radius: 5px;   
    background: #666;
    outline: none;
    opacity: 0.7;
    -webkit-transition: .2s;
    transition: opacity .2s;
}

.slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    border-radius: 50%; 
    background: #3399CC;
    cursor: pointer;
}

.slider::-moz-range-thumb {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #3399CC;
    cursor: pointer;
}
.buttonDias {
  color: #fff;
  background: #3399CC;
  border: 1px solid #ccc;
  padding:auto;
  display: inline-block;
  position: relative;
  left: 5%;
  height:10%;
  min-width: 15%;
  max-width: 25%;
  text-align: center;
  font-size: 0.9vw;
  padding: 1px 1px 1px 1px;
}
.buttonSemanas {
  color: #666;
  background: #fff;
  border: 1px solid #ccc;
  padding:auto;
  display: inline-block;
  position: relative;
  left: 5%;
  height:10%;
  min-width: 20%;
  max-width: 28%;
  text-align: center;
  font-size: 0.9vw;
  padding: 1px 1px 1px 1px;
  /* height: 36px;
  width: 104px; */
}
.buttonHoras {
  color: #666;
  background: #fff;
  border: 1px solid #ccc;
  padding: auto;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  display: inline-block;
  position: relative;
  left: 5%;
  height:10%;
  min-width: 18%;
  max-width: 25%;
  font-size: 0.9vw;
  padding: 1px 1px 1px 1px;
}
.buttonMeses {
  color: #666;
  background: #fff;
  border: 1px solid #ccc;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  display: inline-block;
  position: relative;
  left: 5%;
  height:10%;
  min-width: 18%;
  max-width: 25%;
  font-size: 0.9vw;
  padding: 1px 1px 1px 1px;
}
.buttonDias:hover {
  background: #ccc;

}
.buttonHoras:hover {
  background: #ccc;

}
.buttonSemanas:hover {
  background: #ccc;

}
.buttonMeses:hover {
  background: #ccc;

}
.text {
  outline: none;
}
.table {
  border-spacing: 10px;
}
.chartjs-bar{
  font-size: 2vw;
}

.legend3{
  background:#33CCFF;
  display:inline-block;
  color:#33CCFF
}
.legend4{
  background:#3399CC;
  display:inline-block;
  color:#3399CC
}
.legendTitle{
  display:inline-block;
  color:#666666
}
.minValueSlider{
  color:#666666;
  font-size: 1.0vw;
}

</style>



// WEBPACK FOOTER //
// src/components/Graficos.vue